import React, { useEffect, useRef, useState } from "react";
import Hls from "hls.js";
import { RiSearchLine } from "react-icons/ri";

const VideoCarousel = () => {
  const videoRef = useRef(null);
  const [isVideoLoaded, setIsVideoLoaded] = useState(false);

  const videoSrc =
    "https://new-dev-elite.s3.me-central-1.amazonaws.com/videobanner/videoBanner.m3u8";

  useEffect(() => {
    const video = videoRef.current;
    if (!video) return;

    if (Hls.isSupported()) {
      const hls = new Hls();
      hls.loadSource(videoSrc);
      hls.attachMedia(video);

      hls.on(Hls.Events.MANIFEST_PARSED, () => {
        video.play();
        setIsVideoLoaded(true);
      });
    } else if (video.canPlayType("application/vnd.apple.mpegurl")) {
      video.src = videoSrc;
      video.addEventListener("loadedmetadata", () => {
        video.play();
        setIsVideoLoaded(true);
      });
    }
  }, []);

  return (
    <div className="w-100 mx-auto position-relative">
      {/* Video Container */}
      <div
        className="video-container"
        style={{
          position: "relative",
          width: "100%",
          height: "94vh",
          overflow: "hidden",
        }}
      >
        {/* Poster Fallback */}
        {!isVideoLoaded && (
          <img
            src="/images/video-poster.jpg"
            alt="Video Poster"
            style={{
              position: "absolute",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              objectFit: "cover",
              zIndex: 1,
            }}
          />
        )}

        {/* Video Element */}
        <video
          ref={videoRef}
          autoPlay
          loop
          muted
          playsInline
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            objectFit: "cover",
            opacity: isVideoLoaded ? 1 : 0,
            transition: "opacity 0.5s ease-in-out",
            zIndex: 2,
          }}
        >
          Your browser does not support the video tag.
        </video>
      </div>

      {/* Overlay Content */}
      <div className="position-absolute top-0 start-0 w-100 h-100 d-flex flex-column align-items-center justify-content-center text-center p-3 z-3">
        {/* Search Input */}
        {/* <div
          className="position-relative w-100 d-flex justify-content-center mb-4"
          style={{ bottom: "220px" }}
        >
          <input
            type="text"
            placeholder="Search Here..."
            className="form-control"
            style={{
              maxWidth: "clamp(450px, 80%, 950px)",
              height: "52px",
              borderRadius: "50px",
              paddingLeft: "20px",
              paddingRight: "50px",
              backgroundColor: "rgba(255, 255, 255, 0.2)",
              border: "none",
              backdropFilter: "blur(12px)",
              fontSize: "1rem",
              fontWeight: "500",
            }}
          />
          <RiSearchLine
            style={{
              position: "absolute",
              right: "calc(50% - min(45vw, 475px) + 15px)",
              top: "50%",
              transform: "translateY(-50%)",
              color: "#c69933",
              fontSize: "2rem",
              cursor: "pointer",
              transition: "all 0.3s ease",
            }}
          />
        </div> */}

        {/* Headline */}
        <h1
          className="fw-semibold text-white z-3"
          style={{
            fontSize: "clamp(2.5rem, 6vw, 5rem)",
            maxWidth: "90%",
            lineHeight: "1.2",
          }}
        >
          BEAUTY AND HEALTH <br /> REDEFINED
        </h1>
      </div>
    </div>
  );
};

export default VideoCarousel;
